import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-brand-rose" data-id="element-180" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-181" data-mp="3b143x9u7tf3q">
        <h2 id="testimonios" className="font-display text-base font-extrabold uppercase leading-tight text-brand-choco sm:text-xl" data-id="element-182" data-mp="36yzeyoepp6nf">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1 max-w-xl font-script text-[0.9rem] italic leading-snug text-brand-pinkdark" data-id="element-183" data-mp="2x09vir763e52">
          De no saber por dónde comenzar a comprender cómo preparar productos de
          pastelería.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-184" data-mp="v8589t0m550o">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-brand-blush bg-white p-2.5 text-left text-brand-choco" data-id="element-185" data-mp="qbn7134hrot3" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-186" data-mp="m2onkyoru2ng">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={12} className="fill-brand-gold text-brand-gold" data-id="element-187" data-mp="c6234b0cxdly" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1 text-[0.78rem] italic leading-snug" data-id="element-188" data-mp="14uhfeps3thtl">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto pt-1.5" data-id="element-189" data-mp="q6cvjihbf098">
                <p className="font-display text-[0.75rem] font-extrabold uppercase text-brand-pink" data-id="element-190" data-mp="v57lr5hm3r3d">
                  {t.author}
                </p>
                <p className="text-[0.66rem] leading-snug text-brand-choco/65" data-id="element-191" data-mp="1itzafmvztrbe">
                  {t.role} · {t.location}
                </p>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.15} className="flex h-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-brand-gold bg-brand-choco p-3" data-id="element-192" data-mp="1xh7pwzwc4it6">
            <CtaButton href={OFFER_ANCHOR} data-id="element-193" data-mp="1oj5ia1i3irwx">🚀 Sí, quiero comenzar ahora</CtaButton>
            <p className="mt-1.5 text-[0.68rem] font-medium text-white/85" data-id="element-194" data-mp="1jhyaw3jv7uqs">
              Acceso Inmediato • Garantía de 7 Días
            </p>
          </Reveal>
        </ul>
      </div>
    </section>;
}